import { Refs } from '@solid-primitives/refs';

export enum LockedKey {
  bet_items = 'bet-items',
  bet_type_single = 'bet-type-single',
  bet_type_parlay = 'bet-type-parlay',
  bet_Fast_bet_amount = 'bet-fast-bet-amount',
}

// 这个是ClientOnly的代码，全局声明Store不会有影响
// eslint-disable-next-line no-restricted-syntax
const [store, setStore] = createStore<{
  lockedKeys: string[];
  registerKeys: string[];
}>({
  lockedKeys: [],
  registerKeys: [],
});
export const useLock = () => {
  const register = (key: string) => {
    setStore('registerKeys', (prev) => [...prev, key]);
  };
  const unregister = (key: string) => {
    setStore('registerKeys', (prev) => prev.filter((k) => k !== key));
  };

  const lock = (key: true | string | string[]) => {
    if (key === true) {
      // 全锁
      setStore('lockedKeys', store.registerKeys);
    } else if (typeof key === 'string') {
      setStore('lockedKeys', [...store.lockedKeys, key]);
    } else if (Array.isArray(key)) {
      setStore('lockedKeys', [...store.lockedKeys, ...key]);
    }

    return () => unlock(key);
  };
  const unlock = (key: true | string | string[]) => {
    if (key === true) {
      // 全解锁
      setStore('lockedKeys', []);
    } else if (typeof key === 'string') {
      setStore(
        'lockedKeys',
        store.lockedKeys.filter((k) => k !== key)
      );
    } else if (Array.isArray(key)) {
      setStore(
        'lockedKeys',
        store.lockedKeys.filter((k) => !key.includes(k))
      );
    }
  };

  return {
    register,
    unregister,
    lock,
  };
};

export const ActionLocked = (
  props: ParentProps & {
    lockedKey: string;
  }
) => {
  const { register, unregister } = useLock();

  const [els, setEls] = createSignal<HTMLElement[]>([]);

  onMount(() => register(props.lockedKey));
  onCleanup(() => unregister(props.lockedKey));

  // 派生状态：是否被锁定
  const isLocked = createMemo(() => store.lockedKeys.includes(props.lockedKey));

  createEffect(() => {
    const locked = isLocked();
    const currentEls = els();
    // 只有当元素存在且锁定状态改变时才操作 DOM
    for (const el of currentEls) {
      el.classList.toggle('betSlip-action-locked', locked);
    }
  });

  return <Refs ref={setEls}>{props.children}</Refs>;
};
